import React from 'react';
import TextMessage from './TextMessage';
import MessageWrapper from './MessageWrapper';

const ConversationMessage = ({
  message,
  participantType,
  timestamp,
  status,
  item,
}) => {
  return (
    <MessageWrapper
      participantType={participantType}
      timestamp={timestamp}
      status={status}
      item={item}
    >
      <TextMessage message={message} />
    </MessageWrapper>
  );
};

export default ConversationMessage;
